module.exports = __webpack_public_path__ + "static/media/room-12.5f069c4c.jpeg";